import { Link } from "react-router-dom";
import { Clock, Mail, Truck, ShoppingBag } from "lucide-react";
import { STORE } from "@/config/sections";
import { HOME } from "@/constants/testIds";

const Item = ({ icon: Icon, title, children, testId }) => (
  <div data-testid={testId} className="bg-white border border-[#F0EBE1] rounded-[1.5rem] p-6 flex gap-4">
    <span className="w-11 h-11 shrink-0 rounded-full bg-[#E8F0EC] text-[#2C5242] grid place-items-center"><Icon size={20} /></span>
    <div>
      <p className="font-heading font-bold">{title}</p>
      <div className="mt-1 text-sm text-stone-600">{children}</div>
    </div>
  </div>
);

export const OnlineStore = () => (
  <section data-testid={HOME.storeInfo} className="max-w-7xl mx-auto px-6 lg:px-10 mt-24 grid lg:grid-cols-12 gap-10 items-center">
    <div className="lg:col-span-5 fade-up">
      <h2 className="font-heading text-base md:text-lg font-semibold uppercase tracking-[0.2em] text-[#4E7B68]">Online store</h2>
      <p className="font-heading mt-4 text-3xl sm:text-4xl font-extrabold tracking-tight">Always open. Kiddee never sleeps.</p>
      <p className="mt-4 text-stone-600">Shop any time, day or night, from anywhere in the US. We pack and ship your order fast.</p>
      <Link to="/shop" data-testid={HOME.storeShopButton} className="mt-8 inline-flex items-center gap-2 bg-[#E06D44] text-white px-6 py-3 rounded-full font-medium hover:bg-[#C95B33] transition-colors">
        <ShoppingBag size={16} /> Shop now
      </Link>
    </div>
    <div className="lg:col-span-7 grid sm:grid-cols-3 gap-4 fade-up" style={{ animationDelay: "120ms" }}>
      <Item icon={Clock} title="Open 24/7" testId={HOME.storeHours}>Order online any time, every day of the year.</Item>
      <Item icon={Truck} title="Fast shipping" testId={HOME.storeShipping}>Ships in 1–2 business days. Free over $50.</Item>
      <Item icon={Mail} title="Questions?" testId={HOME.storeEmail}>
        <a href={`mailto:${STORE.email}`} className="hover:text-[#E06D44] transition-colors break-all">{STORE.email}</a>
      </Item>
    </div>
  </section>
);
